module.exports = __webpack_public_path__ + "media/images/emblems/Dully-coat_of_arms-b12d8c28ce37186b0b8aca725c79c2e8.svg";